<template lang="pug">
    div
        p.title {{$t("userInfo.account")}}
        List.content(item-layout="vertical")
            ListItem
                ListItemMeta(:title="$t('userInfo.uploadTitle')" :description="$t('userInfo.uploadDescription')")
                    template(slot="avatar")
                        div(style="border-radius: 50%; overflow: hidden;width: 100px;height: 100px")
                            //- Img(style="width: 100px" src="https://picsum.photos/800")
                            img(src="https://picsum.photos/800" v-real-img="avatarImg" style="max-height: 100px")

                template(slot="extra")
                    li
                        Upload(name="uploads" ref="uploads" action="/api/uploads/avatar" :format="['jpg','jpeg','png']" :max-size="2048" :before-upload="(...args) => { handleBeforeUpload( ...args); }" :on-success="uploadSuccess" :on-format-error="handleFormatError" :show-upload-list="false")
                            Button.cardBtn(type="primary") {{$t("userInfo.upload")}}

            //- modify api token
            //- ListItem
            //-     ListItemMeta(:title="$t('userInfo.apiToken')" :description="apiToken")
            //-     template(slot="extra")
            //-         li(v-if="!$store.state.userData.apiToken")
            //-             Button.cardBtn(type="primary" @click="createApiToken") {{'create'}}
            //-         li(v-else="$store.state.userData.apiToken")
            //-             Button.cardBtn(type="primary" @click="createApiToken") {{'reset'}}

            //- modify email
            ListItem
                ListItemMeta(:title="$t('userInfo.email')" :description="$store.state.userData.email")
                template(slot="extra" v-if="isModifyMail")
                        li(v-if="changeEmail == false")
                            Button.cardBtn(type="primary" @click="editMail") {{$t("userInfo.changeEmail")}}
                        li(v-else-if="mailVerification.verificationCode == '' ")
                            Button.cardBtn(@click="mailVerificationCode") {{$t("userInfo.verifyMailCode")}}
                        li(v-else)
                            Button.cardBtn(@click="mailCancel") {{$t("rcmtable.cancelText")}}
                            Button.cardBtn(type="primary" @click="updateEmail") {{$t("userInfo.save")}}
                template(slot="action" v-if="changeEmail && isModifyMail")
                        Form(style="width: 20vw" :model="userInfo")
                            FormItem
                                div(v-if="mailVerification.verificationCode == ''")
                                    Input(type="text" :placeholder="$t('userInfo.newEmailVerification')" v-model="verificationCode" )
                                div(v-else)
                                    Input(type="email" :placeholder="$t('userInfo.newEmailPlaceholder')" v-model="userInfo.email" pattern="/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/")

            //- modify password and OTP Token
            template(v-if="$store.state.platformPlan.multiTenancyConfigs.forceUpdatePassword && $store.state.userData.isPasswordExpired && $store.state.platformPlan.multiTenancyConfigs.forceUpdateOtpToken && $store.state.userData.isOtpExpired")
                ListItem
                    ListItemMeta(:title="$t('userInfo.passwordAndOtpToken')" :description="lastModifiedPasswordAndOtpTokenDate")

                    template(slot="extra")
                        li(v-if="changePassword == false")
                            Button.cardBtn(type="primary" @click="changePassword = true") {{$t("userInfo.changePasswordAndOtpToken")}}
                        li(v-else)
                            Button.cardBtn(@click="cancel") {{$t("rcmtable.cancelText")}}
                            Button.cardBtn(type="primary" @click="resetUserData" v-if="passCurrentValidation") {{$t("userInfo.saveBoth")}}
                            Button.cardBtn(type="primary" @click="checkCurrentPwd" v-else :disabled="!userInfo.otpToken||!userInfo.password") {{$t("userInfo.verify")}}

                    template(slot="action" v-if="changePassword")
                        Form(style="width: 20vw" ref="currentPwdForm" :model="userInfo" :rules="userInfoValidateRule" v-if="!passCurrentValidation")
                            FormItem(prop="password")
                                Input(type="password" :placeholder="$t('userInfo.currentPwdPlaceholder')" v-model="userInfo.password")
                            FormItem(prop="otpToken")
                                Input(:placeholder="$t('userInfo.tokenPlaceholder')" v-model="userInfo.otpToken" @on-enter="checkCurrentPwd")
                            pre {{userInfo}}

                        Form(style="width: 20vw" ref="newPwdForm" :model="password" :rules="passwordValidateRule" v-else)
                            FormItem(prop="new")
                                Input(type="password" :placeholder="$t('userInfo.newPwdPlaceholder')" v-model="password.new" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" :value="password.new" @on-change="handleOnChange")
                            FormItem(prop="newPwdCheck")
                                Input(type="password" :placeholder="$t('userInfo.checkNewPwdPlaceholder')" v-model="password.newPwdCheck" @on-change="checkNewPassword" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}")
                        Alert(type="warning" refs="message" id="message" v-if="passCurrentValidation")
                            h3 {{$t('userInfo.messageTitle')}}
                            p(ref="same" id="same" class="invalid") {{$t('userInfo.messageSame')}}
                            p(ref="letter" id="letter" class="invalid") {{$t('userInfo.messageLetter')}}
                            p(ref="capital" id="capital" class="invalid") {{$t('userInfo.messageCapital')}}
                            p(ref="number" id="number" class="invalid") {{$t('userInfo.messageNumber')}}
                            p(ref="length" id="length" class="invalid") {{$t('userInfo.messageLength')}}

            //- modify password or modify OTP Token
            template(v-else)
                ListItem
                    ListItemMeta(:title="$t('userInfo.password')" :description="lastModifiedPasswordDate")
                    template(slot="extra")
                        li(v-if="changePassword == false")
                            Button.cardBtn(type="primary" @click="changePassword = true") {{$t("userInfo.editText")}}
                        li(v-else)
                            Button.cardBtn(@click="cancel") {{$t("rcmtable.cancelText")}}
                            Button.cardBtn(type="primary" @click="resetPassword" v-if="passCurrentValidation") {{$t("userInfo.save")}}
                            Button.cardBtn(type="primary" @click="checkCurrentPwd" v-else :disabled="!userInfo.otpToken||!userInfo.password") {{$t("userInfo.verify")}}

                    template(slot="action" v-if="changePassword")
                        Form(style="width: 20vw" ref="currentPwdForm" :model="userInfo" :rules="userInfoValidateRule" v-if="!passCurrentValidation")
                            FormItem(prop="password")
                                Input(type="password" :placeholder="$t('userInfo.currentPwdPlaceholder')" v-model="userInfo.password")
                            FormItem(prop="otpToken")
                                Input(:placeholder="$t('userInfo.tokenPlaceholder')" v-model="userInfo.otpToken" @on-enter="checkCurrentPwd")
                            pre {{userInfo}}

                        Form(style="width: 20vw" ref="newPwdForm" :model="password" :rules="passwordValidateRule" v-else)
                            FormItem(prop="new")
                                Input(type="password" :placeholder="$t('userInfo.newPwdPlaceholder')" v-model="password.new" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" :value="password.new" @on-change="handleOnChange")
                            FormItem(prop="newPwdCheck")
                                Input(type="password" :placeholder="$t('userInfo.checkNewPwdPlaceholder')" v-model="password.newPwdCheck" @on-change="checkNewPassword" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}")
                        Alert(type="warning" refs="message" id="message" v-if="passCurrentValidation")
                            h3 {{$t('userInfo.messageTitle')}}
                            p(ref="same" id="same" class="invalid") {{$t('userInfo.messageSame')}}
                            p(ref="letter" id="letter" class="invalid") {{$t('userInfo.messageLetter')}}
                            p(ref="capital" id="capital" class="invalid") {{$t('userInfo.messageCapital')}}
                            p(ref="number" id="number" class="invalid") {{$t('userInfo.messageNumber')}}
                            p(ref="length" id="length" class="invalid") {{$t('userInfo.messageLength')}}
                ListItem
                    ListItemMeta(:title="$t('userInfo.otp')" :description="lastModifiedOtpTokenDate")
                    template(slot="extra")
                        li
                            Button.cardBtn(type="primary" @click="resetOtpToken") {{$t('userInfo.changeOtpToken')}}

</template>

<script>
import {
    _login,
    setUserAvatar,
    resetUserData,
    getResetMailToken,
    validateResetMailToken,
    resetMail,
    getUserData,
} from "@/api/user";
import { getEsData } from "@/api/esdata";
import { _dateFormat } from "@/libs/dateformat.js";
import { _createApiToken, _getDecryptApiToken } from "@/api/system.js";

export default {
    data() {
        return {
            userInfo: {
                username: this.$store.state.userData.username,
                email: "",
                password: "",
                otpToken: "",
            },
            uploadImageItem: {
                name: "平台Logo圖片",
                key: "headerLogoUpload",
                uploadEndPoint: `/uploads/avatar`,
                currentImageUrlKey: `headerlogoUrl`,
                handleUpload: {
                    format: ["jpg", "jpeg", "png", "svg"],
                    // 上傳成功後更新的欄位
                    successUpdateFields: ["headerlogo"],
                },
                showUploadList: true,
                loadingStatus: false,
            },
            uploadPath: "/uploads/avatar",
            changeEmail: false,
            changePassword: false,
            changeOtp: false,
            validateNewPassword: "",
            passValidation: false,
            passCurrentValidation: false,
            password: {
                new: "",
                newPwdCheck: "",
            },
            userInfoValidateRule: {
                password: [
                    {
                        validator: (rule, value, callback) => {
                            if (value === "") {
                                callback(new Error(this.$t("userInfo.currentPwdPlaceholder")));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur",
                    },
                ],
                otpToken: [
                    {
                        validator: (rule, value, callback) => {
                            if (value === "") {
                                callback(new Error($t("userInfo.tokenPlaceholder")));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur",
                    },
                ],
            },
            passwordValidateRule: {
                new: [
                    {
                        validator: (rule, value, callback) => {
                            if (value === "") {
                                callback(new Error(this.$t("userInfo.currentPwdPlaceholder")));
                            } else {
                                if (this.password.newPwdCheck !== "") {
                                    // 对第二个密码框单独验证
                                    this.$refs.newPwdForm.validateField("newPwdCheck");
                                }
                                callback();
                            }
                        },
                        trigger: "blur",
                    },
                ],
                newPwdCheck: [
                    {
                        validator: (rule, value, callback) => {
                            if (value === "") {
                                callback(new Error(this.$t("userInfo.checkNewPwdPlaceholder")));
                            } else if (value !== this.password.new) {
                                callback(new Error(this.$t("userInfo.newPwdValidateErrorText")));
                            } else {
                                callback();
                            }
                        },
                        trigger: "blur",
                    },
                ],
            },
            avatarImg: this.$store.state.userData.avatarUrl,
            userBody: {},
            // componentKey: 0,
            mailVerification: {
                token: "",
                verificationCode: "",
            },
            verificationCode: "",
            apiToken: "",
        };
    },
    methods: {
        async editMail() {
            this.changeEmail = true;
            let getMailtoken = await getResetMailToken();
            if (getMailtoken.data.success) {
                this.$Notice.success({
                    title: this.$t("global.success"),
                    desc: `${getMailtoken.data.message}`,
                });
                this.mailVerification = getMailtoken.data.data;
            } else {
                this.$Notice.warning({
                    title: this.$t("global.error"),
                    desc: `${getMailtoken.data.message}`,
                });
            }
        },
        async mailVerificationCode() {
            this.mailVerification.verificationCode = this.verificationCode;
            let validateMailtoken = await validateResetMailToken({ data: this.mailVerification });
            if (validateMailtoken.data.success) {
                this.$Notice.success({
                    title: this.$t("global.success"),
                    desc: `${validateMailtoken.data.message}`,
                });
            } else {
                this.$Notice.warning({
                    title: this.$t("global.error"),
                    desc: `${validateMailtoken.data.message}`,
                });
                this.mailVerification.verificationCode = "";
            }
        },
        mailCancel() {
            this.changeEmail = false;
            this.mailVerification = {};
            this.verificationCode = "";
        },
        cancel() {
            this.changePassword = false;
            this.userInfo = {};
        },
        handleBeforeUpload(file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const _base64 = reader.result;
                this.avatarImg = _base64;
            };
            return true;
        },
        uploadSuccess(response, file, fileList) {
            this.$Notice.success({
                title: this.$t("global.success"),
                desc: `${response.message}`,
            });
        },
        handleFormatError(file) {
            this.$Notice.warning({
                title: this.$t("global.errorFile"),
                desc: `${file.name} ${this.$t("rcmtable.validateUnsupportedText")}`,
            });
        },
        async checkCurrentPwd() {
            await _login(this.userInfo)
                .then((res) => {
                    this.passCurrentValidation = true;
                })
                .catch((err) => {
                    this.passCurrentValidation = false;
                    this.$Message.error(this.$t("userInfo.currentValidateErrorText"));
                });
        },
        // resetPassword() {
        //     if (this.passValidation) {
        //         resetPassword({ password: this.password.new })
        //             .then((response) => {
        //                 this.$Notice.success({
        //                     title: this.$t("global.success"),
        //                     desc: `${response.data.message}`,
        //                 });
        //                 if (!response.data.success) throw new Error(response.data.message);
        //                 this.changePassword = false;
        //                 this.getReqBody();
        //             })
        //             .catch((err) => {
        //                 this.$Notice.warning({
        //                     title: this.$t("global.error"),
        //                     desc: `${err.data.message}`,
        //                 });
        //             });
        //     }
        // },
        checkNewPassword() {
            let same = this.$refs.same;
            let letter = this.$refs.letter;
            let capital = this.$refs.capital;
            let number = this.$refs.number;
            let length = this.$refs.length;

            if (
                same.classList.value == "valid" &&
                letter.classList.value == "valid" &&
                capital.classList.value == "valid" &&
                number.classList.value == "valid" &&
                length.classList.value == "valid" &&
                this.password.newPwdCheck == this.password.new
            ) {
                this.passValidation = true;
            } else {
                this.passValidation = false;
            }
        },
        handleOnChange() {
            let same = this.$refs.same;
            let letter = this.$refs.letter;
            let capital = this.$refs.capital;
            let number = this.$refs.number;
            let length = this.$refs.length;

            // validate same
            if (this.password.new !== this.userInfo.password) {
                same.classList.remove("invalid");
                same.classList.add("valid");
            } else {
                same.classList.remove("valid");
                same.classList.add("invalid");
            }

            // validate lowercase letters
            let lowerCaseLetters = /[a-z]/g;
            if (this.password.new.match(lowerCaseLetters)) {
                letter.classList.remove("invalid");
                letter.classList.add("valid");
            } else {
                letter.classList.remove("valid");
                letter.classList.add("invalid");
            }

            // validate capital letters
            let upperCaseLetters = /[A-Z]/g;
            if (this.password.new.match(upperCaseLetters)) {
                capital.classList.remove("invalid");
                capital.classList.add("valid");
            } else {
                capital.classList.remove("valid");
                capital.classList.add("invalid");
            }

            // validate numbers
            let numbers = /[0-9]/g;
            if (this.password.new.match(numbers)) {
                number.classList.remove("invalid");
                number.classList.add("valid");
            } else {
                number.classList.remove("valid");
                number.classList.add("invalid");
            }

            // validate length
            if (this.password.new.length >= 8) {
                length.classList.remove("invalid");
                length.classList.add("valid");
            } else {
                length.classList.remove("valid");
                length.classList.add("invalid");
            }
        },
        async resetUserData() {
            if (this.passValidation) {
                this.userBody["passwordNew"] = this.password.new;
                this.userBody["isResetPassword"] = true;
                this.userBody["isResetOtp"] = true;
                console.log("resetUserData case both>>", this.userBody);

                await resetUserData(this.userBody)
                    .then((res) => {
                        console.log(res);
                        this.$Notice.success({
                            title: this.$t("global.success"),
                            desc: `${res.data.message}`,
                        });
                        this.changePassword = false;

                        setTimeout(() => {
                            this.$store.commit("SET_USER_DATA", {});
                            this.$router.push({ name: "login" });
                        }, 3000);
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$Notice.warning({
                            title: this.$t("global.error"),
                            desc: `${err.message}`,
                        });
                    });
            }
        },
        async resetPassword() {
            if (this.passValidation) {
                this.userBody["passwordNew"] = this.password.new;
                this.userBody["isResetPassword"] = true;
                this.userBody["isResetOtp"] = false;
                // console.log("resetUserData case password>>", this.userBody);

                await resetUserData(this.userBody)
                    .then((res) => {
                        console.log(res);
                        this.$Notice.success({
                            title: this.$t("global.success"),
                            desc: `${res.data.message}`,
                        });
                        this.changePassword = false;

                        setTimeout(() => {
                            this.$store.commit("SET_USER_DATA", {});
                            this.$router.push({ name: "login" });
                        }, 3000);
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$Notice.warning({
                            title: this.$t("global.error"),
                            desc: `${err.message}`,
                        });
                    });
            }
        },
        async resetOtpToken() {
            this.userBody["passwordNew"] = "";
            this.userBody["isResetPassword"] = false;
            this.userBody["isResetOtp"] = true;
            this.userBody['inGroupsRole']= this.$store.state.userData.inGroupsRole

            await resetUserData(this.userBody)
                .then((res) => {
                    console.log(res);
                    this.$Notice.success({
                        title: this.$t("global.success"),
                        desc: `${res.data.message}`,
                    });
                    this.changePassword = false;

                    setTimeout(() => {
                        this.$store.commit("SET_USER_DATA", {});
                        this.$router.push({ name: "login" });
                    }, 3000);
                })
                .catch((err) => {
                    console.log(err);
                    this.$Notice.warning({
                        title: this.$t("global.error"),
                        desc: `${err.message}`,
                    });
                });
        },
        async updateEmail() {
            if (!/^[^@]+@\w+(\.\w+)+\w$/.test(this.userInfo.email)) {
                return this.$Message.error(this.$t("userInfo.emailValidateErrorText"));
            }

            let data = Object.assign({}, this.mailVerification);
            data.mail = this.userInfo.email;

            let validateMailtoken = await resetMail({ data });
            if (validateMailtoken.data.success) {
                this.$Notice.success({
                    title: this.$t("global.success"),
                    desc: `${validateMailtoken.data.message}`,
                });
                let userDataResult = await getUserData();
                let userData = userDataResult.data;
                this.$store.commit("SET_USER_DATA", userData);
                this.changeEmail = false;
            } else {
                this.$Notice.warning({
                    title: this.$t("global.error"),
                    desc: `${validateMailtoken.data.message}`,
                });
                this.mailVerification.verificationCode = "";
            }
        },
        async getReqBody() {
            await getEsData({
                isFuzzySearch: true,
                esIndex: "rcm-users",
                from: 0,
                size: 10,
                sort: [
                    {
                        modifiedDate: {
                            order: "desc",
                        },
                    },
                ],
                filters: [
                    // {
                    //     key: "groupName",
                    //     type: "string",
                    //     value: this.$store.state.queryGroupName,
                    // },
                    {
                        key: "username",
                        type: "string",
                        value: this.$store.state.userData.username,
                    },
                ],
            })
                .then((res) => {
                    this.userBody = res.data.mapData[0] == undefined ? {} : res.data.mapData[0];
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async createApiToken() {
            let result = await _createApiToken();
            if (result.data.success) {
                let userData = result.data.data;
                this.$store.commit("SET_USER_DATA", userData);
                this.getDecryptApiToken();
                this.$Message.success(this.$t("global.success"));
            } else {
                this.$Message.error(result.data.message);
            }
        },
        async getDecryptApiToken() {
            let apiToken = this.$store.state.userData.apiToken;
            if (!apiToken) return;
            let result = await _getDecryptApiToken(apiToken);
            if (result.data.success) {
                this.apiToken = result.data.apiToken;
            } else {
                this.apiToken = "";
            }
        },
    },
    computed: {
        lastModifiedPasswordAndOtpTokenDate() {
            if (
                this.$store.state.userData.lastModifiedPasswordDate == undefined &&
                this.$store.state.userData.lastModifiedOtpTokenDate == undefined
            ) {
                return this.$t("userInfo.changePasswordAndOtpToken");
            } else {
                return (
                    this.$t("userInfo.lastModifiedPasswordDescription") +
                    _dateFormat(`${this.$store.state.userData.lastModifiedPasswordDate}`, "YYYY-MM-DD HH:mm:ss") +
                    ". " +
                    this.$t("userInfo.lastModifiedOtpTokenDescription") +
                    _dateFormat(`${this.$store.state.userData.lastModifiedOtpTokenDate}`, "YYYY-MM-DD HH:mm:ss")
                );
            }
        },
        lastModifiedPasswordDate() {
            if (this.$store.state.userData.lastModifiedPasswordDate == undefined) {
                return this.$t("userInfo.editText");
            } else {
                return (
                    this.$t("userInfo.lastModifiedPasswordDescription") +
                    _dateFormat(`${this.$store.state.userData.lastModifiedPasswordDate}`, "YYYY-MM-DD HH:mm:ss")
                );
            }
        },
        lastModifiedOtpTokenDate() {
            if (this.$store.state.userData.lastModifiedOtpTokenDate == undefined) {
                return this.$t("userInfo.changeOtpToken");
            } else {
                return (
                    this.$t("userInfo.lastModifiedOtpTokenDescription") +
                    _dateFormat(`${this.$store.state.userData.lastModifiedOtpTokenDate}`, "YYYY-MM-DD HH:mm:ss")
                );
            }
        },
        isModifyMail() {
            return this.$store.state.platformPlan.multiTenancyConfigs.updateMail;
        },
    },
    created() {
        this.getReqBody();
        this.getDecryptApiToken();
    },
};
</script>

<style lang="less" scoped>
.title {
    font-size: 24px;
}
.content {
    margin-top: 20px;
}
.ivu-form-item {
    margin-bottom: 0px;
}
#message {
    display: block;
    position: relative;
    padding: 20px;
    margin-top: 50px;
}
#message p {
    padding: 10px 35px;
    font-size: 14px;
}
.valid {
    color: green;
}
.valid:before {
    position: relative;
    left: -35px;
    content: "✔";
}
.invalid {
    color: red;
}
.invalid:before {
    position: relative;
    left: -35px;
    content: "✖";
}
</style>



// WEBPACK FOOTER //
// src/view/general/AccountInfo/userInfo.vue